import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Explain } from 'docz';
import { Icon, Character, Table, Text } from '@components';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "character"
    }}>{`Character`}</h2>
    <TagVersion component="Character" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Character" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'<Text status=\"error\">\n  Nintendo owns the copyright of these characters. Please comply with the\n  Nintendo guidelines and laws of the applicable jurisdiction.\n</Text>\n<Text status=\"error\">\n  任天堂拥有这些角色的版权。请遵守任天堂指南和适用司法管辖区的法律。\n</Text>\n<Character name=\"nes-mario\" />\n<Character name=\"nes-ash\" />\n<Character name=\"nes-pokeball\" />\n<Character name=\"nes-bulbasaur\" />\n<Character name=\"nes-charmander\" />\n<Character name=\"nes-squirtle\" />\n<Character name=\"nes-kirby\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Explain,
      Icon,
      Character,
      Table,
      Text,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="应用图标" mdxType="Playground">
  <Text status="error" mdxType="Text">
    Nintendo owns the copyright of these characters. Please comply with the Nintendo guidelines and laws of the applicable jurisdiction.
  </Text>
   <Text status="error" mdxType="Text">
    任天堂拥有这些角色的版权。请遵守任天堂指南和适用司法管辖区的法律。
  </Text>
  <Character name="nes-mario" mdxType="Character" />
  <Character name="nes-ash" mdxType="Character" />
  <Character name="nes-pokeball" mdxType="Character" />
  <Character name="nes-bulbasaur" mdxType="Character" />
  <Character name="nes-charmander" mdxType="Character" />
  <Character name="nes-squirtle" mdxType="Character" />
  <Character name="nes-kirby" mdxType="Character" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.character].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
            {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      